import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BorrowingBaseService } from '@core/services';

@Component({
  selector: 'oiq-exemption-dialog',
  templateUrl: './exemption-dialog.component.html',
  styleUrls: ['./exemption-dialog.component.scss'],
  standalone: false,
})
export class ExemptionDialogComponent implements OnInit {
  form: UntypedFormGroup;

  constructor(
    private bbService: BorrowingBaseService,
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<ExemptionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      reason: ['', Validators.required],
      tenantId: [''],
      fundingId: [''],
      exemptionType: [''],
    });
  }

  submit() {
    this.form.get('tenantId').setValue(this.data.tenantId);
    this.form.get('fundingId').setValue(this.data.fundingId);
    this.form.get('exemptionType').setValue(this.data.exemptionType);
    this.bbService.addExemption(this.form.value).subscribe((r: any) => {
      this.dialogRef.close(r);
    });
  }
}
